import { Col, Container, Row } from "react-bootstrap";
import Footer from "../../comman/footer";
import Header from "../../comman/header";
import { Link, useParams } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";
import { newsAndEventDetails as newsAndEventDetailsApi } from "../../../helpers/api";
import InlineLoader from "../../comman/InlineLoader";
import config from "../../../config";
import CommonMeta from "../../comman/CommonMeta";
import { useTranslation } from "react-i18next";
import PageNotFound from "../pageNotFound";

const NewsAndEventDetails = ({ page, content, article }) => {
  const params = useParams();

  const [loading, setLoading] = useState(true);
  const [newsAndEventsData, setNewsAndEventsData] = useState([]);

  useEffect(() => {
    if (article) return;

    let active = true;
    const fetchData = async () => {
      setLoading(true);
      setNewsAndEventsData([]);
      try {
        const { data } = await newsAndEventDetailsApi(decodeURI(params.title));
        if (active) setNewsAndEventsData(data.result);
      } catch (error) {
        // Keep the existing news page's error behavior.
      } finally {
        if (active) setLoading(false);
      }
    };

    fetchData();
    return () => {
      active = false;
    };
  }, [article, params.title]);
  const htmlDecode = (content) => {
    let e = document.createElement("div");
    e.innerHTML = content;
    const decoded = e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;

    if (!page?.pressReleaseUrl) return decoded;

    e.innerHTML = decoded;
    e.querySelectorAll("a").forEach((link) => {
      if (/^view\s+press\s+release$/i.test(link.textContent.trim())) {
        link.setAttribute("href", page.pressReleaseUrl);
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener noreferrer");
        link.removeAttribute("download");
      }
    });
    return e.innerHTML;
  };
  const { t } = useTranslation();
  const details = article || newsAndEventsData;
  const isLoading = !article && loading;
  const DetailsWrapper = page?.className ? "main" : Fragment;
  const wrapperProps = page?.className ? { className: page.className } : {};
  const Heading = page ? "h2" : "h4";

  if (article && params.slug !== article.slug) return <PageNotFound />;
  if (page && !isLoading && !details?.title) return <PageNotFound />;

  return (
    <>
      <CommonMeta
        title={page ? details?.title || page.label : "Recent News and Events Updates at Poddar Pigments Ltd"}
        description={page ? details?.shortContent || `${page.label} | Poddar Pigments Limited` : "Stay updated with the latest news and events at Poddar Pigments Ltd. Join us on our journey of innovation and progress."}
        keywords={page?.keywords || "new & events updates, plastic masterbatch manufacturer, masterbatch company in India, color masterbatch manufacturer,"}
        name={page?.label || "News & Event"}
        type="article"
      />
      <Header />
      <DetailsWrapper {...wrapperProps}>
        <div
          className={`top-banner-image ${page?.bannerImage ? "about-us-bg" : "news-bg"}`}
          style={page?.bannerImage ? { backgroundImage: `url(${page.bannerImage})` } : undefined}
        >
          {page?.bannerTitle && (
            <Container>
              <Row>
                <Col xs={12}>
                  <div className="top-heading-text">
                    <h1>{page.bannerTitle}</h1>
                  </div>
                </Col>
              </Row>
            </Container>
          )}
        </div>
        <div className="breadcrumb-wrapper">
          <Container>
            <Row>
              <Col lg={12}>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb investorRelations">
                    <li className="breadcrumb-item">
                      <Link to="/">{t("Home")}</Link>
                    </li>
                    <li className="breadcrumb-item" aria-current="page">
                      <Link to={page?.path || "/news-events-and-awards"}>
                        {t(page?.label || "News And Events")}
                      </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      {page ? details?.title || page.label : <Link> {t(`${params.title}`)}</Link>}
                    </li>
                  </ol>
                </nav>
              </Col>
            </Row>
          </Container>
        </div>

        <Container>
          <InlineLoader loading={isLoading} />
          {!isLoading && (
            <Row className={`news-details${page?.detailsClassName ? ` ${page.detailsClassName}` : ""}`}>
              <Col lg={2}> </Col>
              <Col lg={8}>
                <Heading className={page?.titleClassName}>
                  {details?.title}
                </Heading>
                <img
                  loading="lazy"
                  src={article ? article.image : `${config.NEWS_AND_EVENT_IMG_URL}/${details?.image}`}
                  className="img-fluid"
                  alt={page ? details?.title : ""}
                />
                {content ? (
                  <div className="SearchResult-body">{content}</div>
                ) : (
                  <div
                    dangerouslySetInnerHTML={{ __html: htmlDecode(details?.content) }}
                    className="SearchResult-body"
                  ></div>
                )}
              </Col>
              <Col lg={2}> </Col>
            </Row>
          )}
        </Container>
      </DetailsWrapper>
      <Footer />
    </>
  );
};
export default NewsAndEventDetails;
